import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { UrlBuilder } from "@app/shared/helpers";
import { FaqCreate } from "@app/shared/models/faq/faq-create.model";
import { FaqResponse } from "@app/shared/models/faq/faq-response.model";
import { FaqUpdate } from "@app/shared/models/faq/faq-update.model";
import { environment } from "@env/environment";
import { Observable } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class FaqService {
  private readonly http = inject(HttpClient);

  public getFaqById(id: number): Observable<FaqResponse> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('faq', id.toString())
      .build();
    return this.http.get<FaqResponse>(url);
  }

  public updateFaqById(id: number, faqUpdate: FaqUpdate): Observable<FaqResponse> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('faq', id.toString())
      .build();
    return this.http.put<FaqResponse>(url, faqUpdate);
  }

  public deleteFaqById(id: number): Observable<unknown> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('faq', id.toString())
      .build();
    return this.http.delete(url);
  }

  public getAllFaqs(): Observable<FaqResponse[]> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('faq')
      .build();
    return this.http.get<FaqResponse[]>(url);
  }

  public createFaq(postFaq: FaqCreate): Observable<FaqResponse> {
    const url: string = UrlBuilder.create(environment.apiUrl)
      .addQuerySegments('faq')
      .build();
    return this.http.post<FaqResponse>(url, postFaq);
  }
}
